<template>
<div class="about">
  <div class="mx-auto" max-width="auto">
    <v-img transition="fade-transition" :src="require('../assets/head_bg2.jpg')" height="auto" style="background-color: #101522;">
      <v-row align="center" justify="center">
        <h2 class="font-weight-light white--text">About Us</h2>
        <v-col class="text-center white--text" cols="12">
          <h1 class="display-1 font-weight-thin mb-4">devSentinel CSSS, a brief history</h1>
          <h4 class="text-left body-1 font-weight-light" style="margin:15px">An underground software developer since 2001, who started designing and building applications and databases for Multi-Purpose Cooperative meanwhile implementing full
            accounting interconnectivity of their business operations. Later in 2006, with MCSS marketing the potentials, we offer evaluation with extensive development of the accounting software for the Biliran Electric Cooperative, Inc. and later
            end up with a contract in March 2008. In the same year, we built the Real Property Tax System of the Province of Biliran. We also developed and implemented the Integrated Accounting System for three (3) more Electric Cooperatives in
            Region 8, namely LEYECO III, NORSAMELCO, and SAMELCO I.</h4>
        </v-col>
      </v-row>
    </v-img>

    <v-card-title class="d-block text-right pa-2 black white--text font-weight-light orange--text">
      Local Software Builder
    </v-card-title>

    <v-card-subtitle class="d-block text-right pa-2 black white--text">
      <v-icon dark x-small>fas fa-map-marker-alt</v-icon> Biliran Island, Philippines
    </v-card-subtitle>

    <v-card-actions>
      <!--v-btn text>Share</v-btn>
      <v-btn
        color="purple"
        text
      >
        Explore
      </v-btn-->
      <div class="text-left">
        <i>
          <h2>To our Clients:</h2>
        </i>
        Your continued subscription to the "Software Maintenance and Upgrade Plan" is much appreciated. It is your appreciation and support that nourishes our innovations.
      </div>
      <v-spacer></v-spacer>

      <v-btn icon class="ma-2" outlined color="indigo" @click="show = !show">
        <v-icon>{{ show ? 'fas fa-caret-up' : 'fas fa-caret-down' }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>
        <v-card-text class="text-center" style="background-color:grey; color:white">
          <h3><span class="red--text">CLIENTS</span></h3>
          <div class="body-1" v-for="(client, index) in clients " :key="index">
            <!--a :href="client.webURL" style="text-decoration: none; color: inherit;"-->
            {{client.Name}}
            <!--/a-->
          </div>
        </v-card-text>
      </div>
    </v-expand-transition>
  </div>
</div>
</template>

<script>
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'

export default {
  data: () => ({
    show: false,
    clients: [{
        Name: 'BILECO',
        webURL: ''
      },
      {
        Name: 'LEYECO 3',
        webURL: ''
      },
      {
        Name: 'NORSAMELCO',
        webURL: ''
      },
      {
        Name: 'SAMELCO 1',
        webURL: ''
      },
      {
        Name: 'ASEMCO',
        webURL: ''
      },
      {
        Name: 'SAPARI',
        webURL: ''
      },
      {
        Name: 'AMPC',
        webURL: ''
      },
      {
        Name: 'NCCCI',
        webURL: ''
      },
      {
        Name: 'BILIRAN PROVINCIAL ASSESSOR',
        webURL: ''
      },
    ]
  }),
}
</script>
